import script from "./AssinaturasCompartilhadas.vue?vue&type=script&setup=true&lang=js"
export * from "./AssinaturasCompartilhadas.vue?vue&type=script&setup=true&lang=js"

import "./AssinaturasCompartilhadas.vue?vue&type=style&index=0&id=008921cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008921cc"]])

export default __exports__